import { PublicLayout } from '../components/Layout/PublicLayout'
import { DownloadPage } from '@jotta/ui/DownloadPage'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { ErrorBoundary } from '@sentry/react'
import { Suspense } from 'react'

export const DownloadPageRoute = () => {
  return (
    <PublicLayout section="download">
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorPage error={error} resetError={resetError} hideFooter />
        )}
      >
        <Suspense fallback={<LoadingOverlay open />}>
          <DownloadPage />
        </Suspense>
      </ErrorBoundary>
    </PublicLayout>
  )
}
